import { gettext } from '~/i18n/catalog'

export const values = {
  Buy: 'Buy',
  Sell: 'Sell',
}

export function toText(value) {
  switch (value) {
    case values.Buy:
      return gettext('Buy')
    case values.Sell:
      return gettext('Sell')
    default:
      return value
  }
}
